import React from "react";


export default function Upload({ label, id, feedbackText, status, setUploadError, isRequired, files, setFiles }) {
    // const [files, setFiles] = React.useState([]);

    const handleFileChange = (event) => {
        const uploadedFiles = Array.from(event.target.files);
        setFiles(prevFiles => [...(Array.isArray(prevFiles) ? prevFiles : []), ...uploadedFiles]);
    
        if (uploadedFiles.length > 0) {
            setUploadError(false);
        }
    };

    const removeFile = (fileName) => {
        const updatedFiles = files.filter(file => file.name !== fileName);
        setFiles(updatedFiles);

        console.log(">removeFile<");

        // if (updatedFiles.length === 0) {
        //     console.log( 1 );
        //     setUploadError(true);
        // }
    };

    const formatFileSize = (size) => {
        return (size / (1024 * 1024)).toFixed(2);
    };

    return (
        <div className="br-upload mt-4">
            <label className="upload-label" htmlFor={id} >
                <span style={{ position: "relative", top: "-5px", left: "3px" }}>
                    {label}
                </span>
            </label>
            <input
                className="upload-input"
                id={id}
                type="file"
                onChange={handleFileChange}
                multiple
                style={{ display: "none" }}
            />
            <div
                className="br-drag d-flex align-items-center"
                style={{
                    border: "2px dashed #1351b4",
                    padding: "20px",
                    borderRadius: "6px",
                    cursor: "pointer",
                    backgroundColor: "#f8f9fa",
                    textAlign: "center",
                }}
                onClick={() => document.getElementById(id).click()}
                onDragOver={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    e.currentTarget.style.borderColor = "#0056b3";
                }}
                onDragLeave={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    e.currentTarget.style.borderColor = "#1351b4";
                }}
                onDrop={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    const droppedFiles = Array.from(e.dataTransfer.files);
                    handleFileChange({ target: { files: droppedFiles } });
                    e.currentTarget.style.borderColor = "#1351b4";
                }}
            >
                <i className="fas fa-upload" style={{ fontSize: "20px", color: "#1351b4", marginRight: 10 }}></i>
                <p style={{ margin: 0, color: '#1351b4' }}>Selecione ou arraste o(s) arquivo(s)</p>
            </div>

            {status === "danger" && isRequired && (
                <span className="feedback danger mt-1" role="alert">
                    <i className="fas fa-times-circle"></i> {feedbackText}
                </span>
            )}

            <div className="mt-3">
                {Array.isArray(files) && files.map((file, index) => (
                    <div key={index}>
                        <div
                            className="d-flex justify-content-between align-items-center"
                            style={{
                                padding: "10px 0",
                                width: "100%",
                            }}
                        >
                            <span style={{ textAlign: "left", wordBreak: "break-word", color: '#1351b4' }}>
                                {file.name} - {formatFileSize(file.size)} MB
                            </span>

                            <button name={"btn_remove_"+index}
                                onClick={(e) => {
                                        removeFile(file.name);
                                        e.stopPropagation();
                                    }  
                                }
                                style={{
                                    background: "none",
                                    border: "none",
                                    color: "#dc3545",
                                    cursor: "pointer",
                                    fontSize: "18px",
                                    textAlign: "right",
                                    whiteSpace: "nowrap",
                                }}
                                type="button"
                            >
                                <i className="fas fa-trash-alt"></i>
                            </button>
                        </div>

                        {index < files.length - 1 && <div className="br-divider"></div>}
                    </div>
                ))}
            </div>
        </div>
    );
}
